export default {
      id: "arrow-down-usage",
      viewBox: "0 0 14 8",
      url: "../dist/images/" + "sprite.svg#arrow-down-usage",
      toString: function () {
        return this.url;
      }
    }